<div class="palantir-empty-state" [ngClass]="['palantir-empty-state--size-' + size]">
  <palantir-icon [name]="icon" />

  <div class="palantir-empty-state__content">
    <ng-content />
  </div>

  <ng-content select="[palantir-empty-state-action], palantir-empty-state-action" />
</div>
